import { render } from "./AdminImageVault.vue?vue&type=template&id=4d36ce31&scoped=true"
import script from "./AdminImageVault.vue?vue&type=script&lang=js"
export * from "./AdminImageVault.vue?vue&type=script&lang=js"

import "./AdminImageVault.vue?vue&type=style&index=0&id=4d36ce31&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d36ce31"]])

export default __exports__